import React, { forwardRef } from 'react'
import { Box, useMenuButtonBehavior } from '@maui/elements'

export const TimeRangeFilterMenuButton = forwardRef((props, ref) => {
  return (
    <Box
      {...useMenuButtonBehavior({}, { ...props, ref })}
      color="colorActivePrimary"
      fontSize="12px"
      lineHeight="16px"
      cursor="pointer"
    />
  )
})

TimeRangeFilterMenuButton.displayName = 'TimeRangeFilterMenuButton'
